import React from "react"
import {
  autresActualites,
  actualiteContainerFirst,
  actualiteContainer,
  linkActu,
} from "../actualites.module.scss"
import ActuItem from "../ActuItem/actu-item"
import PropTypes from "prop-types"
import TransitionFade from "../../../transition-fade"

const RenderActualites = ({ actualiteData }) => {
  const actus = actualiteData.allNodeActualites.edges
  const firstActu = actus[0].node
  return (
    <>
      <TransitionFade className={linkActu} link={firstActu.path.alias}>
        <ActuItem myClassName={actualiteContainerFirst} actu={firstActu} />
      </TransitionFade>
      <div className={autresActualites}>
        {actus.slice(1).map(({ node }) => {
          return (
            <ActuItem
              key={node.drupal_id}
              myClassName={actualiteContainer}
              actu={node}
            />
          )
        })}
        <div>
          <TransitionFade className="btn" link="/actualites">
            Toutes nos actualités
          </TransitionFade>
        </div>
      </div>
    </>
  )
}

RenderActualites.propTypes = {
  actualiteData: PropTypes.object.isRequired,
  colors: PropTypes.object,
}

export default RenderActualites
